// extracted by css-extract-rspack-plugin
export default {"Heading":"ErrorPage-module__Heading__Kq7n6Gi","Status":"ErrorPage-module__Status__I13cuV3","Message":"ErrorPage-module__Message__vq6kUs4"};